import PropTypes from 'prop-types';
import { formatTime } from '../../../utils/youtubePractice';

import './VideoTimeline.scss';

/** A video's progress bar, tapped to seek. `range` draws a stretch on it, such as an A–B loop. */
const VideoTimeline = ({ time, duration, onSeek, range = null, label }) => {
  const percent = (s) => (duration ? `${(Math.min(Math.max(s, 0), duration) / duration) * 100}%` : '0%');

  const handleClick = (e) => {
    if (!duration) return;
    const { left, width } = e.currentTarget.getBoundingClientRect();
    onSeek(Math.min(Math.max((e.clientX - left) / width, 0), 1) * duration);
  };

  return (
    <div
      className="VideoTimeline"
      onClick={handleClick}
      role="slider"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={Math.round(duration)}
      aria-valuenow={Math.round(time)}
      aria-valuetext={formatTime(time)}
    >
      <div className="track">
        {range && duration > 0 && (
          <div
            className="range"
            style={{ left: percent(range.a), width: `calc(${percent(range.b)} - ${percent(range.a)})` }}
          />
        )}
        <div className="playhead" style={{ left: percent(time) }} />
      </div>
      <div className="times">
        <span>{formatTime(time)}</span>
        <span>{formatTime(duration)}</span>
      </div>
    </div>
  );
};

VideoTimeline.propTypes = {
  time: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired,
  onSeek: PropTypes.func.isRequired,
  range: PropTypes.shape({ a: PropTypes.number, b: PropTypes.number }),
  label: PropTypes.string.isRequired,
};

export default VideoTimeline;
